// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment_stepTitle__zBFGW {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 15px;
  text-align: center;
}

/* --- Chargify Hosted Fields --- */
.Payment_chargifyFieldsWrapper__EXXJ2 {
  display: flex;
  flex-flow: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px; /* Added margin for spacing */
}

.Payment_chargifyRow__ieTja {
  display: flex;
  gap: 20px;
  width: 100%;
}

.Payment_chargifyField__dBfjI {
  flex: 1 1;
}

.Payment_chargifyField__dBfjI iframe {
  width: 100%;
}

/* Stack the card fields on mobile (Card #/CVV, Month/Year, First/Last),
   matching the full-width entry on the Customer Information step */
@media (max-width: 768px) {
  .Payment_chargifyRow__ieTja {
    flex-direction: column;
    gap: 10px;
  }

  .Payment_chargifyField__dBfjI {
    width: 100%;
  }
}

/* --- Address Input Fields --- */
.Payment_inputGrid__hu9hV {
  display: grid;
  /* 240px min so paired fields stack to full width on phones while staying
     two-up on tablet and desktop (matches Customer Information) */
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.Payment_inputGroup__lXEO8 {
  margin-bottom: 25px;
}

.Payment_inputGroup__lXEO8 label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.Payment_inputGroup__lXEO8 input,
.Payment_inputGroup__lXEO8 select {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  background-color: white;
}

.Payment_inputGroup__lXEO8 input:focus,
.Payment_inputGroup__lXEO8 select:focus {
  outline: none;
  border-color: var(--secondary-bright-blue);
  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);
}

.Payment_inputGroup__lXEO8 input:disabled,
.Payment_inputGroup__lXEO8 select:disabled {
  background-color: #f0f4f8;
  cursor: not-allowed;
}

/* --- Disclaimer --- */
.Payment_chargifyDisclaimerContainer__cp04Y {
  text-align: center;
}

.Payment_chargifyDisclaimer__AF0gv {
  font-size: 1rem;
  font-weight: 500;
  color: var(--primary-dark-blue);
  padding-bottom: 10px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.Payment_loadingOverlay__Vy-TR {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.Payment_errorState__Ic3RV {
  text-align: center;
  padding: 20px;
  color: #e53e3e;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/Payment/Payment.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;mEACmE;AACnE;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb;kEACgE;EAChE,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n/* --- Chargify Hosted Fields --- */\n.chargifyFieldsWrapper {\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 25px; /* Added margin for spacing */\n}\n\n.chargifyRow {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n}\n\n.chargifyField {\n  flex: 1;\n}\n\n.chargifyField iframe {\n  width: 100%;\n}\n\n/* Stack the card fields on mobile (Card #/CVV, Month/Year, First/Last),\n   matching the full-width entry on the Customer Information step */\n@media (max-width: 768px) {\n  .chargifyRow {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .chargifyField {\n    width: 100%;\n  }\n}\n\n/* --- Address Input Fields --- */\n.inputGrid {\n  display: grid;\n  /* 240px min so paired fields stack to full width on phones while staying\n     two-up on tablet and desktop (matches Customer Information) */\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.inputGroup {\n  margin-bottom: 25px;\n}\n\n.inputGroup label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.inputGroup input,\n.inputGroup select {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  background-color: white;\n}\n\n.inputGroup input:focus,\n.inputGroup select:focus {\n  outline: none;\n  border-color: var(--secondary-bright-blue);\n  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);\n}\n\n.inputGroup input:disabled,\n.inputGroup select:disabled {\n  background-color: #f0f4f8;\n  cursor: not-allowed;\n}\n\n/* --- Disclaimer --- */\n.chargifyDisclaimerContainer {\n  text-align: center;\n}\n\n.chargifyDisclaimer {\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--primary-dark-blue);\n  padding-bottom: 10px;\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.loadingOverlay {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n  font-style: italic;\n}\n\n.errorState {\n  text-align: center;\n  padding: 20px;\n  color: #e53e3e;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `Payment_stepTitle__zBFGW`,
	"chargifyFieldsWrapper": `Payment_chargifyFieldsWrapper__EXXJ2`,
	"chargifyRow": `Payment_chargifyRow__ieTja`,
	"chargifyField": `Payment_chargifyField__dBfjI`,
	"inputGrid": `Payment_inputGrid__hu9hV`,
	"inputGroup": `Payment_inputGroup__lXEO8`,
	"chargifyDisclaimerContainer": `Payment_chargifyDisclaimerContainer__cp04Y`,
	"chargifyDisclaimer": `Payment_chargifyDisclaimer__AF0gv`,
	"loadingOverlay": `Payment_loadingOverlay__Vy-TR`,
	"errorState": `Payment_errorState__Ic3RV`
};
export default ___CSS_LOADER_EXPORT___;
